<template>
  <div>
    <slide-view
      :ref="slideRefId"
      :resource="resource"
      :settings="settings"
      :user-data="userData"
    />
    <form-side-bar
      :sb-id="formSBId"
      :sb-model="formSBModel"
      :resource="resource"
      :settings="settings"
      @log-form-click="handleSaveLog"
      @close-clicked="handleCloseFormSideBar"
    />
    <contacts-side-bar
      :sb-id="contactsSBId"
      :sb-model="contactsSBModel"
      :resource="resource"
      @close-clicked="handleCloseContactsSideBar"
    />
    <add-contact-side-bar
      :sb-id="addContactSBId"
      :sb-model="addContactSBModel"
      :resource="resource"
      @add-contact-click="handleSaveContact"
      @close-clicked="handleCloseAddContactSideBar"
    />
    <resource-nav-bar
        v-if="resource"
        :resource="resource"
        @open-about="handleAboutClick"
    >
      <template v-slot:buttons-right>
        <b-button
            variant="outline-primary"
            size="md"
            class="my-2 my-md-0"
            @click="handleOpenContactsSideBar"
            style="margin-right: 15px"
        >
          <b-icon icon="telephone" aria-hidden="true" />
        </b-button>
        <b-button
            variant="outline-primary"
            size="md"
            class="my-2 my-md-0"
            @click="handleOpenAddContactSideBar"
            style="margin-right: 15px"
        >
          <b-icon icon="telephone-plus" aria-hidden="true" />
        </b-button>
        <b-button
            variant="outline-primary"
            size="md"
            class="my-2 my-md-0"
            @click="handleOpenFormSideBar"
        >
          <b-icon icon="clipboard-plus" aria-hidden="true" />
        </b-button>
      </template>
    </resource-nav-bar>
  </div>
</template>

<script>
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import PhotoCard from "./photoCard";
import FormSideBar from "./formSideBar";
import ContactsSideBar from "./contactsSideBar";
import AddContactSideBar from "./contactsAddSideBar";
import SlideView from "./slideView";
export default {
  name: "Display_CallLog",
  mixins: [ResourceBlockDisplay],
  components: {
    PhotoCard,
    ResourceNavBar,
    FormSideBar,
    ContactsSideBar,
    AddContactSideBar,
    SlideView
  },
  props: {},
  created() {},
  mounted() {},
  computed: {
    /* SETTINGS */
    /* SETTINGS */
    /* DATA */
  },
  methods: {
    handleSaveLog(form) {
      let logs = {
        logs: [form]
      };

      let notif = {
        //create message
        title: `Log Saved`,
        description: "Congrats you have updated your family playlist",
        variant: "success"
      };

      const payload = {
        userData: logs,
        notif: notif,
        key: "logs"
      };

      this.handleUpdateUserData(payload);
    },
    handleSaveContact(contact) {
      let logs = {
        contacts: [contact]
      };

      //list wgo the contact is for
      let contactName = contact.isCompany ? contact.company ?  contact.company :''
          : contact.firstname;
      let notif = {
        title: `Contact Save`,
        description: `You have saved the contact for ${contactName}.`,
        variant: "success"
      };

      const payload = {
        userData: logs,
        notif: notif,
        key: "contacts"
      };

      this.handleUpdateUserData(payload);
    },
    /** LOG FORM **/
    handleOpenFormSideBar() {
      this.formSBModel = true;
    },
    handleCloseFormSideBar() {
      this.formSBModel = false;
    },
    /** CONTACTS **/
    handleOpenContactsSideBar() {
      this.contactsSBModel = true;
    },
    handleCloseContactsSideBar() {
      this.contactsSBModel = false;
    },
    /** Add/+ CONTACT **/
    handleOpenAddContactSideBar() {
      this.addContactSBModel = true;
    },
    handleCloseAddContactSideBar() {
      this.addContactSBModel = false;
    },
    handleGoBack() {
      this.$refs[this.slideRefId].handleGoBack();
    }
  },
  data() {
    return {
      slideRefId: "slide-view",
      assetsURLHome: "/assets/apps/calllog/",
      audioDuration: null,
      formSBId: "form-sidebar",
      formSBModel: false,
      contactsSBId: "contacts-sidebar",
      contactsSBModel: false,
      addContactSBId: "add-contact-sidebar",
      addContactSBModel: false,
      /* SLIDE INFO*/
      viewHeight: 250,
      slideId: "audioSlides",
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
